<template>
  <div>
    <div class="page-head">
      <div>
        <h2>线路管理</h2>
        <p>维护小程序展示的旅行线路、封面、价格和推荐信息。</p>
      </div>
      <div><el-button @click="openCategories">管理分类</el-button><el-button type="primary" @click="openCreate">新增线路</el-button></div>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词">
          <el-input v-model="filters.keyword" placeholder="线路名称/分类/亮点" clearable />
        </el-form-item>
        <el-form-item label="展示状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="展示中" value="active" />
            <el-option label="已隐藏" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <paged-table
        :rows="rows"
        :loading="loading"
        :page="page"
        :page-size="pageSize"
        :total="total"
        @page-change="page = $event; fetchList()"
        @size-change="pageSize = $event; page = 1; fetchList()"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="线路名称" min-width="180" />
        <el-table-column prop="category" label="分类" width="120" />
        <el-table-column prop="days" label="天数" width="90" />
        <el-table-column prop="nights" label="晚数" width="90" />
        <el-table-column label="推荐" width="90"><template slot-scope="{ row }"><el-switch :value="Boolean(row.is_recommended)" @change="changeRecommended(row, $event)" /></template></el-table-column>
        <el-table-column prop="price" label="价格" width="110" />
        <el-table-column label="显示价格" width="120">
          <template slot-scope="{ row }">
            <el-switch :value="Boolean(row.price_visible)" @change="changePriceVisible(row, $event)" />
          </template>
        </el-table-column>
        <el-table-column prop="status" label="小程序展示" width="160">
          <template slot-scope="{ row }">
            <publish-switch :value="row.status" @change="changeStatus(row, $event)" />
          </template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="130">
          <template slot-scope="{ row }">
            <sort-input :value="Number(row.sort_order || 0)" @change="changeSort(row, $event)" />
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180"><template slot-scope="{ row }">{{ row.updated_at | dateTime }}</template></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增线路' : '编辑线路'" :visible.sync="drawerVisible" width="860px" destroy-on-close>
      <el-form ref="form" class="drawer-form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="线路名称" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="分类"><el-select v-model="form.category_key" placeholder="请选择稳定分类"><el-option v-for="item in categories" :key="item.category_key" :label="item.name" :value="item.category_key" /></el-select></el-form-item>
        <el-form-item label="封面图" prop="cover_url"><asset-upload v-model="form.cover_url" type="image" category="routes" /></el-form-item>
        <el-form-item label="详情图"><asset-upload v-model="form.detail_image_url" type="image" category="routes" /></el-form-item>
        <el-form-item label="线路视频"><asset-upload v-model="form.video_url" type="video" category="routes" /></el-form-item>
        <el-form-item label="天数"><el-input-number v-model="form.days" :min="1" :max="365" /></el-form-item>
        <el-form-item label="晚数"><el-input-number v-model="form.nights" :min="0" :max="form.days" /></el-form-item>
        <el-form-item label="推荐线路"><el-switch v-model="form.is_recommended" /><div class="field-help">允许推荐多条；小程序推荐页按线路排序值取第一条，其余推荐线路在列表中优先展示。</div></el-form-item>
        <el-form-item label="价格"><el-input-number v-model="form.price" :min="0" :precision="2" /></el-form-item>
        <el-form-item label="显示价格"><el-switch v-model="form.price_visible" /></el-form-item>
        <el-form-item label="详情标签">
          <div class="line-editor">
            <div v-for="(item, index) in form.tags_json" :key="index" class="one-line-row">
              <el-input v-model="form.tags_json[index]" placeholder="例如：北京精选" />
              <el-button type="text" class="danger-text" @click="removeTextItem('tags_json', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addTextItem('tags_json')">添加标签</el-button>
          </div>
        </el-form-item>
        <el-form-item label="集合说明"><el-input v-model="form.gather_text" placeholder="例如：北京集合，北京解散" /></el-form-item>
        <el-form-item label="线路亮点"><el-input v-model="form.summary" type="textarea" :rows="3" /></el-form-item>
        <el-form-item label="线路介绍"><rich-text-editor v-model="form.description" /></el-form-item>
        <el-form-item label="服务卖点">
          <div class="line-editor">
            <div v-for="(item, index) in form.service_features_json" :key="index" class="feature-row">
              <asset-upload v-model="item.icon" type="image" category="routes" compact />
              <el-input v-model="item.title" placeholder="标题，例如：私人讲解" />
              <el-input v-model="item.desc" placeholder="说明，例如：文化路线" />
              <el-button type="text" class="danger-text" @click="removeArrayItem('service_features_json', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addServiceFeature">添加服务卖点</el-button>
          </div>
        </el-form-item>
        <el-form-item label="照片/视频集">
          <div class="line-editor">
            <div v-for="(item, index) in form.media" :key="index" class="media-row">
              <el-select v-model="item.media_type" placeholder="类型">
                <el-option label="图片" value="image" />
                <el-option label="视频" value="video" />
              </el-select>
              <asset-upload v-model="item.media_url" :type="item.media_type === 'video' ? 'video' : 'image'" category="routes" compact />
              <el-input v-model="item.title" placeholder="媒体标题" />
              <el-input-number v-model="item.sort_order" :min="0" placeholder="排序" />
              <el-button type="text" class="danger-text" @click="removeArrayItem('media', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addMedia">添加媒体</el-button>
          </div>
        </el-form-item>
        <el-form-item label="产品亮点">
          <div class="line-editor">
            <div v-for="(item, index) in form.highlights_json" :key="index" class="one-line-row">
              <el-input v-model="form.highlights_json[index]" placeholder="例如：专属讲解老师带队，避开常规团队节奏" />
              <el-button type="text" class="danger-text" @click="removeTextItem('highlights_json', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addTextItem('highlights_json')">添加亮点</el-button>
          </div>
        </el-form-item>
        <el-form-item label="用车安排">
          <div class="stack-editor">
            <el-input v-model="form.car_title" placeholder="标题，例如：专车接送" />
            <asset-upload v-model="form.car_image_url" type="image" category="routes" />
            <el-input v-model="form.car_description" type="textarea" :rows="2" placeholder="用车说明" />
          </div>
        </el-form-item>
        <el-form-item label="住宿安排">
          <div class="line-editor">
            <div v-for="(item, index) in form.stays_json" :key="index" class="image-row">
              <asset-upload v-model="item.image" type="image" category="routes" compact />
              <el-input v-model="item.title" placeholder="住宿标题" />
              <el-input v-model="item.desc" placeholder="住宿说明" />
              <el-button type="text" class="danger-text" @click="removeArrayItem('stays_json', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addStay">添加住宿</el-button>
          </div>
        </el-form-item>
        <el-form-item label="领队列表">
          <div class="line-editor">
            <div v-for="(item, index) in form.leaders_json" :key="index" class="leader-row">
              <asset-upload v-model="item.avatar" type="image" category="routes" compact />
              <el-input v-model="item.name" placeholder="领队姓名" />
              <el-input v-model="item.title" placeholder="身份/标签，例如：文化领队" />
              <el-button type="text" class="danger-text" @click="removeArrayItem('leaders_json', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addLeader">添加领队</el-button>
          </div>
        </el-form-item>
        <el-form-item label="每日行程">
          <div class="line-editor">
            <div v-for="(item, index) in form.itinerary_json" :key="index" class="itinerary-row">
              <el-input-number v-model="item.day" :min="1" placeholder="天" />
              <el-input v-model="item.title" placeholder="行程标题" />
              <el-input v-model="item.desc" placeholder="行程说明" />
              <el-button type="text" class="danger-text" @click="removeArrayItem('itinerary_json', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addItinerary">添加行程</el-button>
          </div>
        </el-form-item>
        <el-form-item label="费用说明">
          <div class="line-editor">
            <div v-for="(item, index) in form.cost_notices_json" :key="index" class="notice-editor-row">
              <el-input v-model="item.title" placeholder="标题，例如：费用包含" />
              <el-input v-model="item.content" placeholder="内容说明" />
              <el-button type="text" class="danger-text" @click="removeArrayItem('cost_notices_json', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addNotice('cost_notices_json')">添加费用说明</el-button>
          </div>
        </el-form-item>
        <el-form-item label="预订须知">
          <div class="line-editor">
            <div v-for="(item, index) in form.booking_notices_json" :key="index" class="notice-editor-row">
              <el-input v-model="item.title" placeholder="标题，例如：退改规则" />
              <el-input v-model="item.content" placeholder="内容说明" />
              <el-button type="text" class="danger-text" @click="removeArrayItem('booking_notices_json', index)">删除</el-button>
            </div>
            <el-button size="small" @click="addNotice('booking_notices_json')">添加预订须知</el-button>
          </div>
        </el-form-item>
        <el-form-item label="套餐类型">
          <div class="package-editor">
            <div v-for="(item, index) in form.packages" :key="index" class="package-row">
              <el-input v-model="item.package_name" placeholder="套餐名称，例如：基础套餐" />
              <el-input-number v-model="item.price" :min="0" :precision="2" placeholder="价格" />
              <el-input v-model="item.description" placeholder="套餐说明" />
              <el-input-number v-model="item.sort_order" :min="0" placeholder="排序" />
              <el-button type="text" class="danger-text" @click="removePackage(index)">删除</el-button>
            </div>
            <el-button size="small" @click="addPackage">添加套餐</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="线路分类管理" :visible.sync="categoryVisible" width="680px">
      <el-form :inline="true" :model="newCategory" size="small">
        <el-form-item label="稳定键"><el-input v-model="newCategory.category_key" placeholder="例如 nature" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="newCategory.name" placeholder="例如 自然慢游" /></el-form-item>
        <el-form-item><el-button type="primary" @click="createCategory">新增分类</el-button></el-form-item>
      </el-form>
      <el-table :data="allCategories" border size="small">
        <el-table-column prop="category_key" label="稳定键" width="150" />
        <el-table-column prop="name" label="分类名称" min-width="150" />
        <el-table-column prop="status" label="状态" width="100"><template slot-scope="{row}"><status-tag :value="row.status" /></template></el-table-column>
        <el-table-column prop="sort_order" label="排序" width="90" />
        <el-table-column label="操作" width="150"><template slot-scope="{row}"><el-button type="text" @click="editCategory(row)">编辑</el-button><el-button type="text" class="danger-text" @click="deleteCategory(row)">删除</el-button></template></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import AssetUpload from "../components/AssetUpload.vue";
import PagedTable from "../components/PagedTable.vue";
import PublishSwitch from "../components/PublishSwitch.vue";
import RichTextEditor from "../components/RichTextEditor.vue";
import SortInput from "../components/SortInput.vue";
import StatusTag from "../components/StatusTag.vue";
import { changeResourceStatus, createResource, deleteResource, listResource, updateResource } from "../api/resources";

export default {
  name: "RoutesManage",
  components: { AssetUpload, PagedTable, PublishSwitch, RichTextEditor, SortInput, StatusTag },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      categories: [],
      allCategories: [],
      categoryVisible: false,
      newCategory: { category_key: "", name: "" },
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: "请填写线路名称", trigger: "blur" }],
        cover_url: [{ required: true, message: "请上传封面图", trigger: "change" }]
      }
    };
  },
  mounted() {
    this.fetchList();
    this.fetchCategories();
  },
  methods: {
    emptyForm() {
      return {
        name: "",
        category: "",
        category_key: "culture",
        cover_url: "",
        detail_image_url: "",
        video_url: "",
        days: 1,
        nights: 0,
        price: 0,
        price_visible: true,
        is_recommended: false,
        packages: [],
        media: [],
        tags_json: [],
        gather_text: "",
        service_features_json: [],
        highlights_json: [],
        car_title: "",
        car_description: "",
        car_image_url: "",
        stays_json: [],
        leaders_json: [],
        itinerary_json: [],
        cost_notices_json: [],
        booking_notices_json: [],
        summary: "",
        description: ""
      };
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("routes", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    async fetchCategories() {
      const res = await listResource("route-categories", { page: 1, pageSize: 100 });
      this.allCategories = res.data && res.data.items ? res.data.items : [];
      this.categories = this.allCategories.filter(item => item.status === "active");
    },
    async openCategories() { this.categoryVisible = true; await this.fetchCategories(); },
    async createCategory() {
      await createResource("route-categories", { ...this.newCategory, status: "active", sort_order: this.allCategories.length * 10 + 10 });
      this.newCategory = { category_key: "", name: "" };
      this.$message.success("分类已新增"); await this.fetchCategories();
    },
    async editCategory(row) {
      const result = await this.$prompt("请输入分类名称", "编辑分类", { inputValue: row.name, inputValidator: value => Boolean(String(value || "").trim()) || "名称不能为空" });
      await updateResource("route-categories", row.id, { ...row, name: result.value });
      this.$message.success("分类已保存"); await this.fetchCategories(); this.fetchList();
    },
    async deleteCategory(row) {
      await this.$confirm("仅无关联线路的分类可删除，确定继续吗？", "删除分类", { type: "warning" });
      await deleteResource("route-categories", row.id); this.$message.success("分类已删除"); await this.fetchCategories();
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = this.emptyForm();
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = {
        ...this.emptyForm(),
        ...row,
        price_visible: Boolean(row.price_visible),
        is_recommended: Boolean(row.is_recommended),
        packages: this.normalizePackages(row.packages),
        media: this.normalizeMedia(row.media),
        tags_json: this.normalizeTextList(row.tags_json),
        service_features_json: this.normalizeServiceFeatures(row.service_features_json),
        highlights_json: this.normalizeTextList(row.highlights_json),
        stays_json: this.normalizeStays(row.stays_json),
        leaders_json: this.normalizeLeaders(row.leaders_json),
        itinerary_json: this.normalizeItinerary(row.itinerary_json),
        cost_notices_json: this.normalizeNotices(row.cost_notices_json),
        booking_notices_json: this.normalizeNotices(row.booking_notices_json)
      };
      this.drawerVisible = true;
    },
    normalizeArray(value) {
      if (Array.isArray(value)) return value;
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    },
    normalizeTextList(value) {
      return this.normalizeArray(value).map((item) => String(item || "")).filter(Boolean);
    },
    normalizeStays(value) {
      return this.normalizeArray(value).map((item) => ({
        image: item.image || "",
        title: item.title || "",
        desc: item.desc || ""
      }));
    },
    normalizeServiceFeatures(value) {
      return this.normalizeArray(value).map((item) => ({
        icon: item.icon || "",
        title: item.title || "",
        desc: item.desc || ""
      }));
    },
    normalizeMedia(media) {
      return (Array.isArray(media) ? media : []).map((item, index) => ({
        id: item.id,
        media_type: item.media_type === "video" ? "video" : "image",
        title: item.title || "",
        media_url: item.media_url || "",
        sort_order: Number(item.sort_order || index)
      }));
    },
    normalizeLeaders(value) {
      return this.normalizeArray(value).map((item) => ({
        avatar: item.avatar || "",
        name: item.name || "",
        title: item.title || ""
      }));
    },
    normalizeItinerary(value) {
      return this.normalizeArray(value).map((item, index) => ({
        day: Number(item.day || index + 1),
        title: item.title || "",
        desc: item.desc || ""
      }));
    },
    normalizeNotices(value) {
      return this.normalizeArray(value).map((item) => ({
        title: item.title || "",
        content: item.content || ""
      }));
    },
    normalizePackages(packages) {
      return (Array.isArray(packages) ? packages : []).map((item, index) => ({
        id: item.id,
        package_name: item.package_name || "",
        price: Number(item.price || 0),
        description: item.description || "",
        sort_order: Number(item.sort_order || index)
      }));
    },
    addPackage() {
      this.form.packages.push({
        package_name: "",
        price: 0,
        description: "",
        sort_order: this.form.packages.length
      });
    },
    removePackage(index) {
      this.form.packages.splice(index, 1);
    },
    addTextItem(field) {
      this.form[field].push("");
    },
    removeTextItem(field, index) {
      this.form[field].splice(index, 1);
    },
    addStay() {
      this.form.stays_json.push({ image: "", title: "", desc: "" });
    },
    addServiceFeature() {
      this.form.service_features_json.push({ icon: "", title: "", desc: "" });
    },
    addMedia() {
      this.form.media.push({ media_type: "image", title: "", media_url: "", sort_order: this.form.media.length });
    },
    addLeader() {
      this.form.leaders_json.push({ avatar: "", name: "", title: "" });
    },
    addItinerary() {
      this.form.itinerary_json.push({ day: this.form.itinerary_json.length + 1, title: "", desc: "" });
    },
    addNotice(field) {
      this.form[field].push({ title: "", content: "" });
    },
    removeArrayItem(field, index) {
      this.form[field].splice(index, 1);
    },
    buildPayload() {
      return {
        ...this.form,
        tags_json: this.normalizeTextList(this.form.tags_json),
        service_features_json: this.form.service_features_json.filter((item) => item.icon || item.title || item.desc),
        media: this.form.media
          .filter((item) => item.media_url)
          .map((item, index) => ({ ...item, sort_order: Number(item.sort_order || index) })),
        highlights_json: this.normalizeTextList(this.form.highlights_json),
        stays_json: this.form.stays_json.filter((item) => item.image || item.title || item.desc),
        leaders_json: this.form.leaders_json.filter((item) => item.avatar || item.name || item.title),
        itinerary_json: this.form.itinerary_json
          .filter((item) => item.title || item.desc)
          .map((item, index) => ({ ...item, day: Number(item.day || index + 1) })),
        cost_notices_json: this.form.cost_notices_json.filter((item) => item.title || item.content),
        booking_notices_json: this.form.booking_notices_json.filter((item) => item.title || item.content)
      };
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          const payload = this.buildPayload();
          if (this.drawerMode === "create") await createResource("routes", payload);
          else await updateResource("routes", payload.id, payload);
          this.$message.success("线路已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    async changeStatus(row, status) {
      await changeResourceStatus("routes", row.id, status);
      this.$message.success(status === "active" ? "线路已展示" : "线路已隐藏");
      this.fetchList();
    },
    async changePriceVisible(row, priceVisible) {
      await updateResource("routes", row.id, { ...row, price_visible: priceVisible });
      this.$message.success(priceVisible ? "价格已显示" : "价格已隐藏");
      this.fetchList();
    },
    async changeRecommended(row, isRecommended) {
      await updateResource("routes", row.id, { ...row, is_recommended: isRecommended });
      this.$message.success(isRecommended ? "已设为推荐线路" : "已取消推荐");
      this.fetchList();
    },
    async changeSort(row, sortOrder) {
      await updateResource("routes", row.id, { ...row, sort_order: sortOrder });
      this.$message.success("排序已更新");
      this.fetchList();
    },
    remove(row) {
      this.$confirm("删除后该线路不会再出现在业务列表中，确定继续吗？", "删除线路", { type: "warning" })
        .then(async () => {
          await deleteResource("routes", row.id);
          this.$message.success("线路已删除");
          this.fetchList();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.package-editor {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.field-help { margin-top: 6px; color: #909399; font-size: 12px; line-height: 1.5; }

.line-editor,
.stack-editor {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.one-line-row,
.feature-row,
.media-row,
.image-row,
.leader-row,
.itinerary-row,
.notice-editor-row {
  display: grid;
  gap: 8px;
  align-items: center;
  min-width: 0;
}

.one-line-row > *,
.feature-row > *,
.media-row > *,
.image-row > *,
.leader-row > *,
.itinerary-row > *,
.notice-editor-row > *,
.package-row > * {
  min-width: 0;
  max-width: 100%;
}

.one-line-row {
  grid-template-columns: minmax(0, 1fr) 48px;
}

.feature-row {
  grid-template-columns: 132px minmax(0, 1fr) minmax(0, 1fr) 44px;
}

.media-row {
  grid-template-columns: 92px 132px minmax(0, 1fr) 128px 44px;
}

.image-row,
.leader-row {
  grid-template-columns: 132px minmax(0, 1fr) minmax(0, 1fr) 44px;
}

.itinerary-row {
  grid-template-columns: 120px minmax(0, 0.85fr) minmax(0, 1.35fr) 44px;
}

.notice-editor-row {
  grid-template-columns: minmax(0, 0.75fr) minmax(0, 1.4fr) 48px;
}

.package-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 130px minmax(0, 1.2fr) 120px 44px;
  gap: 8px;
  align-items: center;
  min-width: 0;
}

.feature-row,
.media-row,
.image-row,
.leader-row,
.itinerary-row,
.notice-editor-row,
.package-row {
  box-sizing: border-box;
  padding: 10px 0;
  background: transparent;
  border-bottom: 1px solid #ebeef5;
}

@media (max-width: 900px) {
  .feature-row,
  .image-row,
  .leader-row,
  .media-row,
  .itinerary-row,
  .package-row {
    grid-template-columns: minmax(0, 1fr) 48px;
    grid-template-rows: none;
  }

  .feature-row > *,
  .image-row > *,
  .leader-row > *,
  .media-row > *,
  .itinerary-row > *,
  .package-row > * {
    grid-column: 1;
    grid-row: auto;
  }

  .feature-row > :last-child,
  .image-row > :last-child,
  .leader-row > :last-child,
  .media-row > :last-child,
  .itinerary-row > :last-child,
  .package-row > :last-child {
    grid-column: 2;
    grid-row: 1;
    align-self: start;
  }
}
</style>
